import { useSetAtom } from 'jotai';
import { useTranslation } from 'next-i18next';
import BlockRegularIcon from 'src/assets/images/icBlockRegular.svg';
import ExitRegularIcon from 'src/assets/images/icExitRegular.svg';
import ShieldReportRegularIcon from 'src/assets/images/icShieldReportRegular.svg';
import Gap from 'src/components/Gap';
import Portal from 'src/components/Portal';
import DMReportModal from 'src/components/Report/DMReportModal';
import useCssMediaDevice from 'src/hooks/useCssMediaDevice';
import { showModalAtom } from 'src/stores/modal/atoms';
import { ModalType } from 'src/types/Modal';
import { DM_REPORT_TYPE_TYPES } from 'src/types/report';
import { MenuIcon, ModalBackdrop, ModalContent, ModalMenuButton, ModalMenuItem, ModalMenuList } from './styles';
interface Props {
  messageThreadId: string;
  buttonRect?: DOMRect;
  onClose: () => void;
  onBlockAndLeave: () => void;
  onLeave: () => void;
}
export default function RoomItemMoreModal({
  messageThreadId,
  buttonRect,
  onClose,
  onBlockAndLeave,
  onLeave
}: Props) {
  const device = useCssMediaDevice();
  const isMobile = device === 'mobile';
  const {
    t
  } = useTranslation();
  const showModal = useSetAtom(showModalAtom);
  const onClickOutside: React.MouseEventHandler<HTMLDivElement> = e => {
    e.stopPropagation();
    onClose();
  };
  const handleReport = () => {
    onClose();
    showModal({
      key: ModalType.DM_REPORT,
      component: () => <DMReportModal messageThreadId={messageThreadId} reportTypes={DM_REPORT_TYPE_TYPES} />
    });
  };
  const handleBlockAndLeave = () => {
    onClose();
    onBlockAndLeave();
  };
  const handleLeave = () => {
    onClose();
    onLeave();
  };
  return <Portal data-sentry-element="Portal" data-sentry-component="RoomItemMoreModal" data-sentry-source-file="RoomItemMoreModal.tsx">
      <ModalBackdrop isDim={isMobile} role='button' tabIndex={0} onClick={onClickOutside} data-sentry-element="ModalBackdrop" data-sentry-source-file="RoomItemMoreModal.tsx" />
      <ModalContent buttonRect={buttonRect} data-sentry-element="ModalContent" data-sentry-source-file="RoomItemMoreModal.tsx">
        <ModalMenuList data-sentry-element="ModalMenuList" data-sentry-source-file="RoomItemMoreModal.tsx">
          <ModalMenuItem data-sentry-element="ModalMenuItem" data-sentry-source-file="RoomItemMoreModal.tsx">
            <ModalMenuButton onClick={handleReport} data-sentry-element="ModalMenuButton" data-sentry-source-file="RoomItemMoreModal.tsx">
              <MenuIcon data-sentry-element="MenuIcon" data-sentry-source-file="RoomItemMoreModal.tsx">
                <ShieldReportRegularIcon data-sentry-element="ShieldReportRegularIcon" data-sentry-source-file="RoomItemMoreModal.tsx" />
              </MenuIcon>
              <Gap width={8} data-sentry-element="Gap" data-sentry-source-file="RoomItemMoreModal.tsx" />
              {t('BUTTON__REPORT')}
            </ModalMenuButton>
          </ModalMenuItem>
          <ModalMenuItem data-sentry-element="ModalMenuItem" data-sentry-source-file="RoomItemMoreModal.tsx">
            <ModalMenuButton onClick={handleBlockAndLeave} data-sentry-element="ModalMenuButton" data-sentry-source-file="RoomItemMoreModal.tsx">
              <MenuIcon data-sentry-element="MenuIcon" data-sentry-source-file="RoomItemMoreModal.tsx">
                <BlockRegularIcon data-sentry-element="BlockRegularIcon" data-sentry-source-file="RoomItemMoreModal.tsx" />
              </MenuIcon>
              <Gap width={8} data-sentry-element="Gap" data-sentry-source-file="RoomItemMoreModal.tsx" />
              {t('dm.block_leave_option')}
            </ModalMenuButton>
          </ModalMenuItem>
          <ModalMenuItem data-sentry-element="ModalMenuItem" data-sentry-source-file="RoomItemMoreModal.tsx">
            <ModalMenuButton onClick={handleLeave} data-sentry-element="ModalMenuButton" data-sentry-source-file="RoomItemMoreModal.tsx">
              <MenuIcon data-sentry-element="MenuIcon" data-sentry-source-file="RoomItemMoreModal.tsx">
                <ExitRegularIcon data-sentry-element="ExitRegularIcon" data-sentry-source-file="RoomItemMoreModal.tsx" />
              </MenuIcon>
              <Gap width={8} data-sentry-element="Gap" data-sentry-source-file="RoomItemMoreModal.tsx" />
              {t('dm.leave_option')}
            </ModalMenuButton>
          </ModalMenuItem>
        </ModalMenuList>
      </ModalContent>
    </Portal>;
}